<template>
  <div class="wrap">
    <div class="page-list">
      <div class="border-bottom">
        <div class="title">
          <span>到货确认</span>
          <span class="gray-font-12 float-right">采购经理或采购方授权人，登录M2B-APP，在收货单上完成电子签名，确认到货。</span>
        </div>
      </div>
      <div class="filter">
        <div class="fast-group">
          <div class="tit" style="color:#666;">快速搜索</div>
          <div class="fast-item" :class="type=='all'?'active':''" @click="type='all'">
            <span>所有</span>
            <span>{{count.all}}</span>
          </div>
          <div class="fast-item" :class="type=='transport'?'active':''" @click="type='transport'">
            <span>在途</span>
            <span>{{count.countUnShipped.qty}}</span>
          </div>
          <div class="fast-item" :class="type=='unAffirm'?'active':''" @click="type='unAffirm'">
            <span>已到货未确认</span>
          </div>
          <div class="fast-item" :class="type=='affirm'?'active':''" @click="type='affirm'">
            <span>已确认</span>
            <span>{{count.countShipped.qty}}</span>
          </div>
        </div>
        <SearchField style="float:right;width:200px;" :small="true" :value.sync="searchText" @submit="getData()" placeholder="订单号 / 物流单号"></SearchField>
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>订单号</th>
            <th style="width:95px;">发货日期</th>
            <th>物流公司</th>
            <th style="width:75px;">商品件数</th>
            <th>发货人</th>
            <th style="width:100px;">签收状态</th>
            <th style="width:100px;">签收日期</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in records" :key="item.id">
            <td>{{ item.salesOrderNumber }}</td>
            <td>{{ item.deliveryTime | toShortDate }}</td>
            <td>
              <span>{{ item.org }}</span>
              <span v-if="item.trackingNumber">({{ item.trackingNumber }})</span>
            </td>
            <td>{{ item.totalQty }}</td>
            <td>{{ item.manufacturerName }}</td>
            <td>{{item.shippingStatus=="SHIPPED"?'已签收':'未签收'}}</td>
            <td class="text-center">
              <span v-if="item.shippingStatus=='SHIPPED'" class="sign-time" @click.stop="view(item)">{{ item.shippedTime | toShortDate }}</span>
              <button v-else @click="sign(item.id)" class="btn btn-secondary btn-sm">确认签收</button>
            </td>
          </tr>
        </tbody>
      </table>
      <div style="margin-top:30px">
        <Pagination :total="total" @page-to="getData" ref="page" />
      </div>
    </div>
    <Signature v-if="showSignDialog" :picId="signaturePicId" :signTime="shippedTime" @affirm="affirm" @close="showSignDialog=false"></Signature>
  </div>
</template>

<script>
import Pagination from "@components/Pagination.vue";
import SearchField from "@components/SearchField.vue";
import Signature from "@components/Signature.vue";

export default {
  components: {
    Pagination,
    SearchField,
    Signature,
  },
  data() {
    return {
      type: "all",
      searchText: "",
      showSignDialog: false,
      signId: "",
      shippedTime: 0, // 查看签收的时间
      signaturePicId: "", // 查看签收的图片
      records: [],
      total: 0,
      count: { all: 0, countShipped: { qty: 0 }, countUnShipped: { qty: 0 } },
    };
  },
  watch: {
    type() {
      this.searchText = "";
      this.$refs.page.pageIndex = 1;
      this.getData();
    },
  },
  created() {
    this.getData();
    this.getCount();
  },
  methods: {
    getCount() {
      this.$post("/opms/logistics/statistics").then((res) => {
        res.all = res.countShipped.qty + res.countUnShipped.qty;
        this.count = res;
      });
    },
    getData(args) {
      var params = {
        criteria: {
          soNumberOrLoNumber: this.searchText,
        },
        limit: args ? args.limit : this.$limit,
        offset: args ? args.offset : 0,
      };
      if (this.type == "transport") {
        params.criteria.shippingStatus = "unshipped";
      } else if (this.type == "unAffirm") {
        params.criteria.shippingStatus = "";
      } else if (this.type == "affirm") {
        params.criteria.shippingStatus = "shipped";
      }
      this.$list("/opms/logistics/query", params, {
        success(data) {
          this.records = data.select.results;
          this.total = data.select.total;
        },
      });
    },
    sign(id) {
      this.signaturePicId = "";
      this.showSignDialog = true;
      this.signId = id;
    },
    view(it) {
      this.shippedTime = it.shippedTime;
      this.signaturePicId = process.env.VUE_APP_OpenFile_URL + "/" + it.signaturePicId;
      this.showSignDialog = true;
    },
    affirm(blob) {
      let formData = new FormData();
      formData.append("file", blob, `签名于-${Date.now()}.jpg`);
      this.$http({
        url: "/shared/storage/parts360-open/upload",
        data: formData,
        method: "post",
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          return this.$post("/opms/logistics/signed", {
            id: this.signId,
            signaturePicId: res.data.uri,
          });
        })
        .then(() => {
          this.showSignDialog = false;
          this.$refs.page.refresh();
        })
        .catch((err) => {
          $msg.error("签收失败");
        });
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  padding: 20px;
  background: #fff;
  .page-list {
    .title {
      margin-bottom: 10px;
      font-size: 24px;
      line-height: 36px;
    }
    .filter {
      padding: 20px 0;
    }
    .table td {
      line-height: 29px;
      .sign-time {
        cursor: pointer;
        color: #ff2b2b;
        text-decoration: underline;
      }
    }
  }
}
</style>